export const segmentsQueryKeys = {
  all: ["orchestratorSegments"] as const,
  lists: () => [...segmentsQueryKeys.all, "list"] as const,
  list: (propertyTicker: string) => [...segmentsQueryKeys.lists(), { propertyTicker }] as const,
  details: () => [...segmentsQueryKeys.all, "detail"] as const,
  detail: (propertyTicker: string, id: string) =>
    [...segmentsQueryKeys.details(), propertyTicker, id] as const,
};
